import { Component, Host, h, Prop, State } from "@stencil/core";
import { ObservableMap } from "@stencil/store";
import { getStore, ILiftStatusState } from "../../store";

@Component({
  tag: "ls-status",
  styleUrl: "ls-status.css",
  shadow: true,
})
export class LsStatus {
  /**
   * Specifies the IDs of the sensors that are to be displayed.
   */
  @Prop() readonly sensorIds = "500,501,502,503,514,515,590";

  /**
   * The unique key that is used to identify store data.
   */
  @Prop() readonly idKey: string;

  /**
   * The sensor IDs input property, converted to an array of numbers.
   */
  @State() sensorIdsArray = this.sensorIds.split(",").map(Number);

  private store: ObservableMap<ILiftStatusState>;

  async componentWillLoad() {
    this.store = await getStore(this.idKey);
    this.handleBackdoor(this.store.state.hasBackDoor);
  }

  private handleBackdoor = (hasBackDoor: boolean) => {
    if (hasBackDoor) return;

    this.sensorIdsArray = this.sensorIdsArray.filter((sensor) => {
      return sensor !== 503;
    });
  };

  render() {
    return (
      <Host>
        <slot></slot>
        {this.sensorIdsArray.map((sensor) => (
          <ls-status-item
            sensor-id={sensor}
            id-key={this.idKey}
          ></ls-status-item>
        ))}
      </Host>
    );
  }
}
